module.exports = __webpack_public_path__ + "img/odeon_logo_on_primary.b5a03a00.png";